import React from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import program_start from "static/image/onboarding/program_start.svg";
import { BottomNextButton } from "../../../../components/common/BottomNextButton";
import useMixpanelMKT from "../../../../hooks/useMixpanelMKT";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "../../../../components/mkt/mktVersionUtils";

export default function Start_4_V6({
  version = "v6",
}: {
  version?: MktVersionTypes;
}) {
  const navigate = useNavigate();

  const trackPromotion = useMixpanelMKT({
    eventName: "프로그램 구성하기 버튼 클릭",
    version: version,
  });

  const handleNext = () => {
    trackPromotion();
    navigate(`/${versionToPathPrefix(version)}-onboarding/start/5`, {
      replace: true,
    });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "70vh" }}>
      <Stack
        sx={{
          height: "100%",
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack spacing={2}>
          <CustomTypography
            variant="Subtitle"
            fontWeight={700}
            sx={{
              color: theme.vars.palette.Content.Highlight,
            }}
          >
            {"과학이 만드는 변화를 지금 시작하세요."}
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {"디스턴싱은 현대 정신의학 이론을 집대성한 전세계 유일의 근거 기반\n" +
              "인지행동치료 프로그램입니다."}
          </CustomTypography>
        </Stack>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 0,
            marginTop: "50px",
          }}
        >
          <img
            src={program_start}
            alt={"onboarding"}
            style={{
              maxWidth: "100%",
              maxHeight: "80%",
              objectFit: "contain",
            }}
          />
        </Box>
      </Stack>
      <BottomNextButton
        disabled={false}
        onClick={handleNext}
        text={"프로그램 구성하기"}
        highlightBackground={true}
      />
    </Box>
  );
}
